import { FC } from 'react';
import { Button, Modal } from 'components/core';
import { DownloadConfirmationModalProps, Styled } from './';
import { useI18n } from 'contexts/i18n';

const DownloadConfirmationModal: FC<DownloadConfirmationModalProps> = ({
  onClose,

}) => {
  const i18n = useI18n();
  return (
    <Modal overlaysize="small">
      <Styled.DownloadConfirmationModalBody>
        {i18n['The file has been downloaded to your desktop.']}
      </Styled.DownloadConfirmationModalBody>
      <Styled.DownloadConfirmationModalFooter>
        <Button variant="primary" onClick={onClose} size="md">
          {i18n['Continue Shopping']}
        </Button>
      </Styled.DownloadConfirmationModalFooter>
    </Modal>
  );
};

export default DownloadConfirmationModal;
